import { render, staticRenderFns } from "./config-manage.vue?vue&type=template&id=b279b71a&scoped=true"
import script from "./config-manage.vue?vue&type=script&lang=js"
export * from "./config-manage.vue?vue&type=script&lang=js"
import style0 from "./config-manage.vue?vue&type=style&index=0&id=b279b71a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b279b71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b279b71a')) {
      api.createRecord('b279b71a', component.options)
    } else {
      api.reload('b279b71a', component.options)
    }
    module.hot.accept("./config-manage.vue?vue&type=template&id=b279b71a&scoped=true", function () {
      api.rerender('b279b71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/components/config-manage.vue"
export default component.exports